module.exports = __webpack_public_path__ + "static/media/05LoganBrothersHaywoodRdmuralprogress.207bea7c.webp";